import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledWizardSubtitle = styled.h2`
    display: flex;
    align-items: center;
    margin-top: 24px;
    margin-bottom: 24px;
    font-size: var(--size-16);
    font-style: normal;
    font-weight: normal;
    line-height: 20px;
    color: var(--color-grey-800);
    @media ${breakpoints.xs} {
        margin-top: 1.5rem;
        margin-bottom: 2.8rem;
        font-size: var(--size-14);
    }
`;
